import React, { useContext } from "react";

import { GlobalContext } from "../../globals/globalContext";
import "./styles.styl";

export default function CalendarIcon(props) {
  const { colorPrimary } = useContext(GlobalContext) || props;

  return (
    <div className="calendar-icon">
      <svg
        width="30"
        height="30"
        viewBox="0 0 29 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.74 3.91854H8.22718C7.69972 3.91854 7.27222 3.49104 7.27222 2.96358C7.27222 2.43613 7.69972 2.00862 8.22718 2.00862H20.74C21.2675 2.00862 21.695 2.43613 21.695 2.96358C21.695 3.49104 21.2678 3.91854 20.74 3.91854Z"
          fill={colorPrimary}
        />
        <path
          d="M27.8532 9.2937H1.11426C0.586806 9.2937 0.159302 8.86619 0.159302 8.33874V5.51524C0.159302 3.58176 1.73244 2.00862 3.66592 2.00862H5.70253C6.22999 2.00862 6.65749 2.43612 6.65749 2.96358C6.65749 3.49104 6.22999 3.91854 5.70253 3.91854H3.66592C2.78544 3.91854 2.06922 4.63476 2.06922 5.51524V7.38378H26.8982V5.51524C26.8982 4.63476 26.182 3.91822 25.3012 3.91822H23.2649C22.7374 3.91822 22.3099 3.49072 22.3099 2.96326C22.3099 2.4358 22.7374 2.0083 23.2649 2.0083H25.3012C27.235 2.00862 28.8081 3.58176 28.8081 5.51524V8.33874C28.8081 8.86619 28.3806 9.2937 27.8532 9.2937Z"
          fill={colorPrimary}
        />
        <path
          d="M25.3012 27.529H3.66592C1.73244 27.529 0.159302 25.9559 0.159302 24.0221V8.33873C0.159302 7.81128 0.586806 7.38377 1.11426 7.38377H27.8532C28.3806 7.38377 28.8081 7.81128 28.8081 8.33873V24.0221C28.8081 25.9559 27.235 27.529 25.3012 27.529ZM2.06922 9.2937V24.0221C2.06922 24.9029 2.78544 25.6191 3.66592 25.6191H25.3012C26.182 25.6191 26.8982 24.9029 26.8982 24.0221V9.2937H2.06922Z"
          fill={colorPrimary}
        />
        <path
          d="M7.7229 15.5474H6.20706C5.74805 15.5474 5.37561 15.1753 5.37561 14.716V13.2001C5.37561 12.7411 5.74773 12.3687 6.20706 12.3687H7.7229C8.18192 12.3687 8.55436 12.7408 8.55436 13.2001V14.716C8.55404 15.175 8.18192 15.5474 7.7229 15.5474Z"
          fill={colorPrimary}
        />
        <path
          d="M15.2416 15.5474H13.7257C13.2667 15.5474 12.8943 15.1753 12.8943 14.716V13.2001C12.8943 12.7411 13.2664 12.3687 13.7257 12.3687H15.2416C15.7006 12.3687 16.073 12.7408 16.073 13.2001V14.716C16.073 15.175 15.7009 15.5474 15.2416 15.5474Z"
          fill={colorPrimary}
        />
        <path
          d="M22.7604 15.5474H21.2445C20.7855 15.5474 20.4131 15.1753 20.4131 14.716V13.2001C20.4131 12.7411 20.7852 12.3687 21.2445 12.3687H22.7604C23.2194 12.3687 23.5918 12.7408 23.5918 13.2001V14.716C23.5918 15.175 23.2197 15.5474 22.7604 15.5474Z"
          fill={colorPrimary}
        />
        <path
          d="M7.7229 22.0854H6.20706C5.74805 22.0854 5.37561 21.7133 5.37561 21.2539V19.7381C5.37561 19.2791 5.74773 18.9066 6.20706 18.9066H7.7229C8.18192 18.9066 8.55436 19.2788 8.55436 19.7381V21.2539C8.55404 21.7133 8.18192 22.0854 7.7229 22.0854Z"
          fill={colorPrimary}
        />
        <path
          d="M15.2416 22.0854H13.7257C13.2667 22.0854 12.8943 21.7133 12.8943 21.2539V19.7381C12.8943 19.2791 13.2664 18.9066 13.7257 18.9066H15.2416C15.7006 18.9066 16.073 19.2788 16.073 19.7381V21.2539C16.073 21.7133 15.7009 22.0854 15.2416 22.0854Z"
          fill={colorPrimary}
        />
        <path
          d="M22.7604 22.0854H21.2445C20.7855 22.0854 20.4131 21.7133 20.4131 21.2539V19.7381C20.4131 19.2791 20.7852 18.9066 21.2445 18.9066H22.7604C23.2194 18.9066 23.5918 19.2788 23.5918 19.7381V21.2539C23.5918 21.7133 23.2197 22.0854 22.7604 22.0854Z"
          fill={colorPrimary}
        />
        <path
          d="M7.39598 5.5337H6.53397C6.07495 5.5337 5.70251 5.16158 5.70251 4.70225V1.22492C5.70251 0.765898 6.07463 0.393463 6.53397 0.393463H7.39598C7.855 0.393463 8.22743 0.76558 8.22743 1.22492V4.70225C8.22711 5.16126 7.855 5.5337 7.39598 5.5337Z"
          fill={colorPrimary}
        />
        <path
          d="M22.4338 5.5337H21.5718C21.1128 5.5337 20.7404 5.16158 20.7404 4.70225V1.22492C20.7404 0.765898 21.1125 0.393463 21.5718 0.393463H22.4338C22.8928 0.393463 23.2653 0.76558 23.2653 1.22492V4.70225C23.265 5.16126 22.8928 5.5337 22.4338 5.5337Z"
          fill={colorPrimary}
        />
      </svg>
    </div>
  );
}
